import React from 'react';

const ReportsPage = () => {
  return <>reports page</>;
};

export default ReportsPage;
